import { Component, OnDestroy, OnInit } from '@angular/core'
import { CartDetailsComponent } from '@spartacus/cart/base/components'
import { CartConfigService } from '@spartacus/cart/base/core'
import { ActiveCartFacade, SelectiveCartFacade } from '@spartacus/cart/base/root'
import { AuthService, RoutingService } from '@spartacus/core'
import { Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { CustomCartService } from '../../../services/custom-cart.service'
import { OrderHistoryService } from '../../../services/order-history.service'
import { ProductDetailsService } from '../../../services/product.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../services/shared/shared.service'
import { ExcludedItemsComponent } from '../../shared/bottom-sheets/excluded-items/excluded-items.component'

@Component({
    selector: 'app-custom-cart-details',
    templateUrl: './custom-cart-details.component.html',
    styleUrls: ['./custom-cart-details.component.scss'],
    standalone: false
})
export class CustomCartDetailsComponent extends CartDetailsComponent implements OnInit, OnDestroy {
  resetCartProductReferences: Subject<boolean> = new Subject<boolean>()

  constructor(
    protected authService: AuthService,
    protected routingService: RoutingService,
    public orderHistoryService: OrderHistoryService,
    public sharedService: SharedService,
    public customCartService: CustomCartService,
    protected activeCartService: ActiveCartFacade,
    public productDetailsService: ProductDetailsService,
    public globalMessageService: CustomGlobalMessageService,
    selectiveCartFacade: SelectiveCartFacade,
    cartConfigService: CartConfigService
  ) {
    super(activeCartService, selectiveCartFacade, authService, routingService, cartConfigService)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.entries$ = this.entries$.pipe(map((entries) => this.customCartService.sortOutOfStockItemsFirst(entries)))
  }

  ngOnDestroy(): void {
    this.clearExcludedItems()
  }

  public onItemRemoved(value): void {
    this.resetCartProductReferences.next(value)
  }

  public showExcludedItems(): void {
    this.sharedService.openBottomSheet(ExcludedItemsComponent)
  }

  public clearExcludedItems(): void {
    if (this.orderHistoryService.excludedItems?.length) {
      this.orderHistoryService.excludedItems.length = 0
    }
  }
}
